import React, { useEffect, useState } from 'react'

import Link from 'next/link'

import BaseHeader, {
  BaseHeaderProps,
} from '@nexys/components/BaseHeader/BaseHeader'
import HamburgerButton from '@nexys/components/HamburgerButton/HamburgerButton'
import LazyImgwrapper from '@nexys/components/LazyImgWrapper'
import { Col, Divider, Drawer, Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { image } from 'constant'

import { getAuthTokenPayload } from 'utils/authStorage'


import ProfileButton from './component/ProfileButton'

import classNames from './Header.module.scss'
import MenuBar from '../MenuBar'

function Header(props: BaseHeaderProps) {
  const [open, setOpen] = useState(false)
  const [user, setUser] = useState({
    token: '',
    fullName: '',
    userId: '',
    profile: '',
  })
  const { xl, sm, lg } = useBreakpoint()
  // XS = MOBILE XL = DESKTOP
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const token = localStorage?.getItem('access_token')
      const tokenData = getAuthTokenPayload()
      if (token && tokenData) {
        setUser({
          ...user,
          token,
          fullName: localStorage?.getItem('full_name'),
          userId: tokenData?.data?.id,
        })
      }
    }
  }, [])

  const showDrawer = () => {
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  return (
    <BaseHeader {...props}>
      <Col flex={'none'}>
        <Row>
          <Col
            style={{
              alignSelf: 'center',
            }}
          >
            <Link href={'/'}>
              <a>
                <LazyImgwrapper>
                  <img
                    className={classNames.logoIllustration}
                    src={image.ilustrationLogo}
                    alt="illustration"
                  />
                </LazyImgwrapper>
              </a>
            </Link>
          </Col>
        </Row>
      </Col>
      <Col
        flex={'auto'}
        style={{
          textAlign: 'end',
          display: 'flex',
          flexDirection: 'row-reverse',
          columnGap: 10,
        }}
      >
        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {/* @ts-ignore */}
          {!xl && <HamburgerButton onClick={showDrawer} />}
        </Row>

        <Row
          style={{
            display: !sm ? 'none' : !lg ? 'none' : '',
          }}
        >
          <ProfileButton />
        </Row>

        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          {/* @ts-ignore */}
          {xl && <MenuBar mode="horizontal" />}
        </Row>

        <Drawer
          title=""
          placement="left"
          onClose={onClose}
          visible={open}
          closable={true}
        >
          {/* @ts-ignore */}
          <MenuBar mode="inline" setOpen={setOpen} />
          <Divider />
          <ProfileButton />
        </Drawer>
      </Col>
    </BaseHeader>
  )
}

export default Header
